class LpUnlockBar extends HTMLElement {
  connectedCallback() {
    document.addEventListener('lp-bundle:change', this.#handleChange);

    // The bundle selector broadcasts its initial selection on its own
    // connectedCallback, but module scripts don't guarantee load order, so
    // that broadcast can fire before this listener is registered. Read the
    // currently-selected tier straight from the DOM as a fallback so the
    // bar reflects the real default (e.g. 3-bottle) on first paint too.
    const selectedTier = document.querySelector('[data-tier].lp-bundle-selector__tier--selected');
    const bundleSelector = document.querySelector('lp-bundle-selector');
    if (selectedTier instanceof HTMLElement) {
      this.#applyState({
        tierPosition: selectedTier.dataset.tierPosition || '1',
        savings: selectedTier.dataset.savings || '',
        tier2Savings: bundleSelector?.dataset.tier2Savings || '',
        tier3Savings: bundleSelector?.dataset.tier3Savings || '',
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener('lp-bundle:change', this.#handleChange);
  }

  /**
   * @param {CustomEvent<{tierPosition: string, savings: string, tier2Savings: string, tier3Savings: string}>} event
   */
  #handleChange = (event) => {
    this.#applyState(event.detail);
  };

  /**
   * @param {{tierPosition: string, savings: string, tier2Savings: string, tier3Savings: string}} detail
   */
  #applyState(detail) {
    const { tierPosition, savings, tier2Savings } = detail;

    /** @type {Record<string, { message: string, savings: string, progress: number, state: 'locked' | 'unlocked', badge: string }>} */
    const tierConfig = {
      1: { message: this.dataset.messageTier1, savings: tier2Savings, progress: 33, state: 'locked', badge: '33%' },
      2: { message: this.dataset.messageTier2, savings, progress: 100, state: 'unlocked', badge: '✓' },
      3: { message: this.dataset.messageTier3, savings, progress: 100, state: 'unlocked', badge: '✨' },
    };

    const config = tierConfig[tierPosition] || tierConfig['1'];
    if (!config) return;

    this.dataset.state = config.state;

    const fill = this.querySelector('[data-fill]');
    if (fill instanceof HTMLElement) fill.style.width = `${config.progress}%`;

    const badge = this.querySelector('[data-badge]');
    if (badge) badge.textContent = config.badge;

    const label = this.querySelector('[data-label]');
    if (label && config.message) {
      label.textContent = config.message.replace('{savings}', config.savings || '');
    }
  }
}

if (!customElements.get('lp-unlock-bar')) {
  customElements.define('lp-unlock-bar', LpUnlockBar);
}
